import React, { forwardRef } from 'react';

import { NumberInput } from '../NumberInput';

export const PriceInput = forwardRef((props, ref) => (
  <NumberInput {...props} prefix="R$: " decimalPlaces={2} ref={ref} />
));
